module.exports = __webpack_public_path__ + "img/weather64.405b3886.png";